import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import webReducer from "./webSlice";
export const store = configureStore({
  reducer: {
    auth: authReducer,
    web: webReducer,
  },
});
